<template>
  <div class="pagination-soft-area">
    <div class="total-soft">共 {{ total }} 条记录</div>
    <el-pagination
      class="soft-el-pagination"
      background
      layout="prev, pager, next, sizes"
      :current-page="currentPage"
      :page-size="pageSize"
      :page-sizes="pageSizes"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50]
    }
  },
  methods: {
    handleSizeChange(size) {
      this.$emit('size-change', size);
    },
    handleCurrentChange(page) {
      this.$emit('current-change', page);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pagination.vue